import React from "react";
import { useTimer } from "../Context/TimerContext";

function TimerDisplay() {
  const seconds = useTimer(); // This component now consumes the timer context

  return (
    <span style={{ marginLeft: "24px" }}>
      {/* <Tooltip title="Delay Picking Orders">
        <Badge
          badgeContent={unreleasedOrders || "0"}
          color="warning"
          sx={{ marginRight: "16px" }}
        >
          <UnpublishedIcon
            color="warning"
            onClick={handleClick}
            sx={{ cursor: "pointer" }}
          />
        </Badge>
      </Tooltip> */}
      Refreshing Dashboard in:{" "}
      <strong>00:{String(seconds).padStart(2, "0")}</strong>
    </span>
  );
}

export default TimerDisplay; // Or export directly if preferred
